export default [
  {
    path: '/admin/defines/stock-groups',
    name: 'StockGroups',
    component: () => import('@/views/Admin/Defines/Stock_groups/Index.vue'),
    meta: {
      pageTitle: 'Stok Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/stock-groups/add',
    name: 'StockGroupAdd',
    component: () => import('@/views/Admin/Defines/Stock_groups/Add.vue'),
    meta: {
      pageTitle: 'Stok Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/stock-groups',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/stock-groups/edit/:id',
    name: 'StockGroupEdit',
    component: () => import('@/views/Admin/Defines/Stock_groups/Edit.vue'),
    meta: {
      pageTitle: 'Stok Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/stock-groups',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
